import React, { useEffect, useState } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
// import { getInventorySuppliers } from "../../../api/inventoryService";
import { getPetOwners } from "../../../api/petOwnerService";

const PetOwnerAutocomplete = ({
  petOwnerId = "",
  value,
  onChange,
  label = "Select Pet Owner",
  ...props
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPetOwners();
        setItems(response?.data || []);
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [petOwnerId]);

  return (
    <Autocomplete
      {...props}
      options={items}
      getOptionLabel={(option) => `${option.first_name} ${option.last_name} (${option.pet_names ? option.pet_names : 'no pets'})` || ""}
      value={
        items.find((item) => item.id === value) || null
      }
      onChange={(event, newValue) =>
        onChange?.(newValue ? newValue.id : "")
      }
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default PetOwnerAutocomplete;